import React, {useState, forwardRef} from "react";
import PropTypes from "prop-types";
import {Button, Grid, Typography} from "@material-ui/core";
import DatePicker from "react-datepicker";
import moment from "moment";
import 'moment/locale/pt-br'

const getSunday = (format = 'DD', selectedDay) => {
  selectedDay = moment(selectedDay).clone();
  const isMonthDifferent = selectedDay.weekday(0).format('M') !== selectedDay.weekday(6).format('M');
  const newFormat = isMonthDifferent ? 'DD [de] MMMM' : 'DD';
  return `${selectedDay.weekday(0).format(newFormat)}`;
}

const getSaturday = (format, selectedDay) => {
  return `${moment(selectedDay).clone().weekday(6).format(format)}`;
}

const getMonth = (format, selectedDay) => {
  const todayMonth = moment(selectedDay).format(format);
  const lastDayMonth = getSaturday(format, selectedDay);
  if (todayMonth !== lastDayMonth ) {
    return lastDayMonth;
  } else {
    return todayMonth;
  }
}

const getYear = (format, selectedDay) => {
  const todayYear = moment(selectedDay).format(format);
  const lastDayYear = getSaturday(format, selectedDay);
  if (todayYear !== lastDayYear ) {
    return lastDayYear;
  } else {
    return todayYear;
  }
}

const formatDate = (selectedDay) => {
  return `${getSunday("DD", selectedDay)} - ${getSaturday("DD", selectedDay)} de ${getMonth("MMMM", selectedDay)} de ${getYear("YYYY", selectedDay)}`;
}

const WeekSelector = ({
  disabled,
  nameStorage,
  onChange,
  selected,
  setFilter,
  value
}) => {

  const [weekSelected, setWeekSelected] = useState(selected);

  const backWeek = (selectedDay) => {
    const previousWeek = moment(selectedDay).subtract(7, 'days')
    setWeekSelected(previousWeek);
    onChange(
      setFilter,
      outputToFilter(previousWeek.valueOf()),
      nameStorage
    );
  }

  const forwardWeek = (selectedDay) => {
    const nextWeek = moment(selectedDay).add(7, 'days');
    setWeekSelected(nextWeek);
    onChange(
      setFilter,
      outputToFilter(nextWeek.valueOf()),
      nameStorage
    );
  }

  const outputToFilter = (ref) => {
    return {
      startDate: getSunday("YYYY-MM-DD", ref),
      ref: moment(ref).valueOf(),
      endDate: getSaturday("YYYY-MM-DD", ref)
    }
  }

  const DatePickerLabel = forwardRef(() => (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
    <Typography
      variant="h6"
      align="center"
      style={{
        fontFamily: 'Roboto',
        fontSize: "1rem",
        lineHeight: "1.1rem",
      }}
    >
      {formatDate(selected)}
    </Typography>
    </div>
  ));

  return (
    <Grid container>
      <Grid item xs={8}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <DatePicker
            locale="pt-BR"
            customInput={<DatePickerLabel />}
            selected={selected}
            onChangeRaw={(event) => event.preventDefault()}
            open={false}
            value={value}
            placeholderText={`Filtar por semana`}
            disabled={disabled}
            isClearable={false}
          />
          <Button
              onClick={() => backWeek(weekSelected)}
              variant="contained"
              color="primary"
              style={{
                marginLeft: "5px",
                marginRight: "2.5px",
                minWidth: "10%"
              }}
              size="large"
            >
              {`<`}
          </Button>
          <Button
            onClick={() => forwardWeek(weekSelected)}
            variant="contained"
            color="primary"
            style={{
              marginLeft: "2.5px",
              marginRight: "5px",
              minWidth: "10%"
            }}
            size="large"
          >
            {`>`}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

WeekSelector.propTypes = {
  disabled: PropTypes.bool.isRequired,
  nameStorage: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.number.isRequired,
  setFilter: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default WeekSelector;
